import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { useContext, useEffect, useState } from 'react';
import { Accordion, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { SelectedVehicleContext } from '../../../contexts/vehicle/SelectedVehicleContext.ts';
import { IMission } from '../../../schema/Mission.ts';
import { useMissions } from '../../../services/Mission.ts';
import { MissionCard } from './MissionCard.tsx';

export function Mission() {
  const { t } = useTranslation();
  const { selectedVehicle } = useContext(SelectedVehicleContext);
  const params = useParams() as { territorySlug: string };
  const [showMissionPreview, setShowMissionPreview] = useState(true);
  const [queryParams, setQueryParams] = useState<Record<string, string>>({ page: '1' });

  const { data: missionData, error } = useMissions(params.territorySlug, queryParams);

  const missions = missionData ?? [];
  const previewItems = missions.slice(0, 1);
  const displayList = showMissionPreview ? previewItems : missions;

  useEffect(() => {
    if (missionData) {
      if (selectedVehicle?.id) {
        setQueryParams({
          vehicle_shuttle_provider_identifier: selectedVehicle.shuttle_provider_identifier,
          page: '1',
        });
      } else {
        setQueryParams({ page: '1' });
      }
    }
  }, [missionData, selectedVehicle?.display_identifier, selectedVehicle?.id]);

  return (
    <>
      {error ? (
        <p className={'text-basic text-center'}>{t('mission.error')}</p>
      ) : (
        <>
          <Accordion className={'mission-scroll-container mb-3'}>
            <div className={'accordion accordion-flush text-center'}>
              {displayList.map((mission: IMission, i: number) => (
                <MissionCard key={mission.id} mission={mission} index={i} />
              ))}
            </div>
          </Accordion>
          {missions?.length > 1 && (
            <div className={'row mt-3 mb-3'}>
              <div className={'col text-center'}>
                <Button
                  type={'submit'}
                  className={'submit-button-reverse small-button'}
                  onClick={() => setShowMissionPreview(!showMissionPreview)}>
                  <p className={'my-auto'}>{showMissionPreview ? <DownOutlined /> : <UpOutlined />}</p>
                </Button>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}
